import { ReactElement, useEffect } from 'react';

import { CookieSettingsButton } from '$components/cookie-policy/cookie-settings-button';

import styles from './cookie-list.module.scss';

export function CookieList(): ReactElement {
  useEffect(() => {
    if (window?.OneTrust) {
      window.OneTrust.initializeCookiePolicyHtml?.();
    }
  }, [window?.OneTrust]);

  return (
    <div className={`box ${styles.cookieListWrapper}`}>
      <div className={`flex flex__jc--flex-end ${styles.cookieSettingsButtonWrapper}`}>
        <CookieSettingsButton />
      </div>
      <div id="ot-sdk-cookie-policy" />
    </div>
  );
}
